import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from './assets/BunnyBoutiqueLogo-NavyPinkNoBackground.png';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Our Bunnies', path: '/our-bunnies' },
  { label: 'Available', path: '/available' },
  { label: 'Past Babies', path: '/past-babies' },
  { label: 'Application', path: '/application' },
  { label: 'Merchandise', path: '/merchandise' },
  { label: 'Contact', path: '/contact' },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bunny-nav-container">

      <div className="bunny-brand">
        <Link to="/" onClick={() => setIsOpen(false)}>
          <img src={logo} alt="Bunny Boutique 321" style={{ height: '52px', width: 'auto' }} />
        </Link>
      </div>

      <button
        type="button"
        className="bunny-hamburger-btn"
        onClick={toggleMenu}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
        aria-controls="bunny-nav-links"
      >
        <span className="bunny-bar-line"></span>
        <span className="bunny-bar-line"></span>
        <span className="bunny-bar-line"></span>
      </button>

      <div id="bunny-nav-links" className={`bunny-links-wrapper ${isOpen ? 'is-open' : ''}`}>
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`bunny-link ${location.pathname === link.path ? 'active-link' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}

export default Navbar;
